import { useReactModal, autoId } from '@workday/upc-common';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import Modal from 'react-modal';
import '../../SettingsModalContent.scss';
import { useGetAuthenticatorQuery } from '../../../../slices/account-api.slice';
import { LoadingDots } from '@workday/canvas-kit-react';
import { ChangeAuthenticatorSteps } from './change-authenticator-steps';
import { RegisterAuthenticatorEntry } from './RegisterAuthenticatorEntry';
import { useTranslation } from 'react-i18next';
import { ID_REGISTER_AUTHENTICATOR_BUTTON, ID_UPDATE_AUTHENTICATOR_BUTTON } from '../../../../autoIds';
import React from 'react';

export function AuthenticatorSettingsRow() {
    const { t } = useTranslation('account');
    const registerAuthenticatorModal = useReactModal({ modalProps: { shouldCloseOnEsc: false } });
    const updateAuthenticatorModal = useReactModal({ modalProps: { shouldCloseOnEsc: false } });

    const { isLoading, isSuccess } = useGetAuthenticatorQuery();

    return (
        <div className='settingsRow'>
            <h1 className='settingsRow__title'>{t('AuthenticatorSettingsRow.title')}</h1>
            <div className='settingsRow__content'>
                {isLoading ? (
                    <LoadingDots role='progressbar' />
                ) : (
                    <>
                        <p>{t('AuthenticatorSettingsRow.extraLayerSecurity')}</p>
                        {isSuccess ? (
                            <SecondaryButton
                                {...autoId(ID_UPDATE_AUTHENTICATOR_BUTTON)}
                                type='button'
                                onClick={updateAuthenticatorModal.open}>
                                {t('AuthenticatorSettingsRow.openUpdateAuthenticatorModal')}
                            </SecondaryButton>
                        ) : (
                            <SecondaryButton
                                {...autoId(ID_REGISTER_AUTHENTICATOR_BUTTON)}
                                type='button'
                                onClick={registerAuthenticatorModal.open}>
                                {t('AuthenticatorSettingsRow.openRegisterAuthenticatorModal')}
                            </SecondaryButton>
                        )}
                    </>
                )}
                <Modal {...updateAuthenticatorModal.modalProps}>
                    <ChangeAuthenticatorSteps onCloseModal={updateAuthenticatorModal.close} />
                </Modal>
                <Modal {...registerAuthenticatorModal.modalProps}>
                    <RegisterAuthenticatorEntry onCloseModal={registerAuthenticatorModal.close} />
                </Modal>
            </div>
        </div>
    );
}
